export const operationsKeys = {
  overview: () => ['operations', 'overview'] as const,
};
